document.addEventListener('DOMContentLoaded', () => {
  let observer;

  /* -------------------------------------------
   * 1) HELPER: Bind "Select Store" & Postal Search
   * ------------------------------------------- */
  function bindStoreButtons(scope) {
    // Bind the "Select Store" buttons
    const storeButtons = scope.querySelectorAll('.select-store-btn:not([data-bound])');
    storeButtons.forEach((button) => {
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const storeId = button.dataset.storeId;
        document.cookie = `preferred_store=${storeId}; path=/; max-age=2592000`;
        location.reload();
      });
    });

    // Bind the postal‑code lookup
    const postalInput = document.getElementById('postal-code-input');
    const postalBtn   = document.getElementById('postal-code-search-btn');
    if (postalBtn && !postalBtn.dataset.bound) {
      postalBtn.dataset.bound = 'true';
      postalBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const postalCode = postalInput.value.trim();
        if (!postalCode) {
          alert('Please enter a postal code');
          return;
        }
        geocodeAndSortByPostal(postalCode);
      }, true);
    }
  }

  /* -------------------------------------------
   * 2) HELPER: Preferred Store → Top + Style
   * ------------------------------------------- */
  function reorderPreferredStore() {
    const cookies = document.cookie.split(';').reduce((acc, cur) => {
      const [k, v] = cur.trim().split('=');
      acc[k] = v;
      return acc;
    }, {});
    const preferred = cookies.preferred_store;
    if (!preferred) return;

    function moveAndStyle(selector) {
      const container = document.querySelector(selector);
      if (!container) return;
      const el = container.querySelector(`[data-store-id="${preferred}"]`);
      if (!el) return;
      if (el !== container.firstElementChild) container.prepend(el);
      const btn = el.querySelector('.select-store-btn');
      if (btn) btn.remove();
      el.style.border  = '2px solid green';
      el.style.padding = '0.5rem';
    }

    moveAndStyle('.pickup-status');
    moveAndStyle('.drawer__content ul');
  }

  /* -------------------------------------------
   * 3) HELPER: Distance Sorting
   * ------------------------------------------- */
  function haversineDistance(lat1, lng1, lat2, lng2) {
    function toRad(x) { return x * Math.PI/180; }
    const R = 6371;
    const dLat = toRad(lat2-lat1);
    const dLng = toRad(lng2-lng1);
    const a = Math.sin(dLat/2)**2 +
              Math.cos(toRad(lat1))*Math.cos(toRad(lat2))*
              Math.sin(dLng/2)**2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  }

  function sortSideDrawerByDistance(userLat, userLng) {
    const ul = document.querySelector('.drawer__content ul');
    if (!ul) return;
    const items = Array.from(ul.querySelectorAll('li.pickup-store'));
    const arr = items.map(el => {
      const lat = parseFloat(el.dataset.lat);
      const lng = parseFloat(el.dataset.lng);
      const dist = (!isNaN(lat)&&!isNaN(lng))
        ? haversineDistance(userLat,userLng,lat,lng)
        : Infinity;
      return { el, dist };
    });
    arr.sort((a,b) => a.dist - b.dist)
       .forEach(({ el }) => ul.appendChild(el));
  }

  /* -------------------------------------------
   * 4) HELPER: Postal‑Code → Geocode via Maps JS
   * ------------------------------------------- */
  function geocodeAndSortByPostal(postalCode) {
    if (!window.google || !google.maps || !google.maps.Geocoder) {
      console.error('Google Maps API not loaded');
      alert('Location services unavailable.');
      return;
    }
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode(
      { address: postalCode, componentRestrictions: { country: 'CA' } },
      (results, status) => {
        if (status !== 'OK' || !results || !results[0]) {
          alert('Could not find that postal code.');
          return;
        }
        const loc = results[0].geometry.location;
        sortSideDrawerByDistance(loc.lat(), loc.lng());
      }
    );
  }

  /* -------------------------------------------
   * 5) HELPER: Stock Filter Toggle
   * ------------------------------------------- */
  function bindStockFilter() {
    const cb = document.getElementById('filter-stock-checkbox');
    if (!cb) return;
    cb.addEventListener('change', () => {
      document.querySelectorAll('li.pickup-store').forEach(li => {
        const qty = parseInt(li.dataset.quantity||'0',10);
        li.style.display = cb.checked ? (qty>0?'':'none') : '';
      });
    });
  }

  /* -------------------------------------------
   * 6) HELPER: PDP Only One Store
   * ------------------------------------------- */
  function filterPDPStore() {
    const container = document.querySelector('.pickup-status');
    if (!container) return;
    const stores = Array.from(container.querySelectorAll('.pickup-store'));
    if (stores.length <= 1) return;

    const cookies = document.cookie.split(';').reduce((acc,cur)=>{
      const [k,v]=cur.trim().split('=');
      acc[k]=v; return acc;
    }, {});
    const preferred = cookies.preferred_store;
    let keep = stores.find(el=>el.dataset.storeId===preferred)
            || stores[0];

    observer.disconnect();
    stores.forEach(el=>el.remove());
    container.insertBefore(keep, container.firstChild);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* -------------------------------------------
   * 7) INIT + MutationObserver
   * ------------------------------------------- */
  bindStoreButtons(document);
  reorderPreferredStore();
  bindStockFilter();

  observer = new MutationObserver(mutations => {
    let added = false;
    for (const m of mutations) {
      if (m.type === 'childList' && m.addedNodes.length) {
        m.addedNodes.forEach(node => {
          if (node.nodeType===1) {
            bindStoreButtons(node);
            added = true;
          }
        });
      }
    }
    if (added) {
      reorderPreferredStore();
      bindStockFilter();
      filterPDPStore();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  filterPDPStore();
});
